import script from "./DeleteButtonComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./DeleteButtonComponent.vue?vue&type=script&setup=true&lang=js"

import "./DeleteButtonComponent.vue?vue&type=style&index=0&id=540750fe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-540750fe"]])

export default __exports__